import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, reactive, ref } from 'vue';
import { BaseProps, BaseCascader } from '../ts/index';
import moduleOption from './option';

interface cascader extends BaseProps<any> {
  options?: BaseCascader,
  type?: string,
  source?: { [key: string]: any },
  target: Array<string>,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    options: {},
    type: {},
    source: {},
    target: {},
    className: {},
    visible: { type: Boolean },
    size: {},
    placeholder: { default: '请选择' },
    disabled: { type: Boolean, default: false },
    readOnly: { type: Boolean },
    defaultValue: { default: reactive([]) },
    value: {},
    onChange: {}
  },
  emits: ["onChange", "onsetData"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit

const props = __props;

const value = reactive([]);

const setTarget = (e) => {
  if (props.target) {
    props.target.forEach((key, index) => {
      const value = e[index] == null ? null : e[index];
      if (key) props.source[key] = value;
    });
  }
};

const filter = (inputValue: string, path: any[]) => {
  return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
};

const handleSelect = (e, option) => {
  value.length = 0;
  value.push(...e);
  setTarget(e);
  emit('onChange');
};

const options = computed(() => {
  if (props.options) return props.options;
  const { type } = props;
  if (!type) return [];
  if (!moduleOption[type]) throw new Error(`module中无参数${type}选项`);
  return moduleOption[type]
});

const echoData = () => {
  if (props.source && props.target.length > 0) {
    value.length = 0;
    props.target.forEach((key) => {
      if (!props.source[key]) return;
      value.push(props.source[key]);
    });
  }
};

echoData();

__expose({
  echoData
})


return (_ctx: any,_cache: any) => {
  const _component_a_cascader = _resolveComponent("a-cascader")!

  return (_openBlock(), _createBlock(_component_a_cascader, {
    value: value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value) = $event)),
    options: options.value,
    placeholder: props.placeholder,
    onChange: handleSelect,
    allowClear: "",
    disabled: props.disabled,
    "show-search": { filter: filter }
  }, null, 8, ["value", "options", "placeholder", "disabled", "show-search"]))
}
}

})